import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

// API endpoints
const API_LIST = '/crm-expense-sub-category';
const API_DETAIL = (id: number) => `/crm-expense-sub-category/${id}`;

export interface ExpenseSubCategory {
  id: number;
  name?: string;
  exp_category_id?: number;
  exp_category_desc?: {
    id: number;
    name?: string;
  };
}

export const useExpenseSubCategories = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<ExpenseSubCategory[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    expenseSubCategories: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const useExpenseSubCategory = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<ExpenseSubCategory>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    expenseSubCategory: data,
    isLoading,
    isError: error,
    mutate,
  };
};

